import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/utils';

export type LabelProps = ComponentPropsWithoutRef<'label'>;

const Label = ({ className, ...props }: LabelProps) => {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-base leading-5 font-semibold tracking-[-0.03em] select-none',
        'group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]/field:opacity-25',
        'peer-disabled:cursor-not-allowed peer-disabled:opacity-25',
        'peer-aria-invalid:text-red-400',
        className,
      )}
      {...props}
    />
  );
};

export default Label;
